import type { HealthRecord } from "../types";
import { localDateKey } from "./records";

export interface MonthDay {
  key: string;
  date: Date;
  day: number;
  inMonth: boolean;
  today: boolean;
  records: HealthRecord[];
}

export function buildMonthDays(month: Date, now: Date, records: HealthRecord[]): MonthDay[] {
  const recordsByDate = new Map<string, HealthRecord[]>();
  for (const record of records) {
    const key = localDateKey(new Date(record.recordedAt));
    const dayRecords = recordsByDate.get(key) ?? [];
    dayRecords.push(record);
    recordsByDate.set(key, dayRecords);
  }
  for (const dayRecords of recordsByDate.values()) {
    dayRecords.sort((left, right) => right.recordedAt.localeCompare(left.recordedAt));
  }

  const first = new Date(month.getFullYear(), month.getMonth(), 1);
  const mondayOffset = (first.getDay() + 6) % 7;
  const gridStart = new Date(first);
  gridStart.setDate(first.getDate() - mondayOffset);
  const todayKey = localDateKey(now);

  return Array.from({ length: 42 }, (_, index) => {
    const date = new Date(gridStart);
    date.setDate(gridStart.getDate() + index);
    const key = localDateKey(date);
    return {
      key,
      date,
      day: date.getDate(),
      inMonth: date.getMonth() === month.getMonth() && date.getFullYear() === month.getFullYear(),
      today: key === todayKey,
      records: recordsByDate.get(key) ?? [],
    };
  });
}
